import React from 'react';
import { useParams } from 'react-router-dom';

import ClientsAdvertisersForm from '../components/Advertisers/AdvertisersForm';

function ClientsAdvertisersFormPage() {
  const {
    id,
    advertiserId,
  } = useParams();

  return (
    <ClientsAdvertisersForm
      id={Number(advertiserId)}
      clientId={Number(id) || undefined}
    />
  );
}

export default ClientsAdvertisersFormPage;
